
/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';



// component
const Component: React.FunctionComponent<any> = (props: InterfaceInputText<string,any>): JSX.Element =>{

    const { type, name , id , className ,placeholder, onChange } = props;

    return(
        
        <input type={type} placeholder={placeholder} name={name} id={id} className={className} onChange={onChange} autoComplete="OFF"/>
           
    )
}

// interface 
export interface InterfaceInputText<T , A>{
    type: T,
    name?: T,
    id : A,
    placeholder: T,
    className: T,
    onChange: React.EventHandler<React.ChangeEvent<HTMLInputElement>>
}

/**
 * DefaultProps values
 */
Component.defaultProps= {

}

export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@widgets/input-text/component.tsx